import { useEffect } from 'react'
import Typography from '@mui/material/Typography'
import IconButton from '@mui/material/IconButton'
import Card from '@mui/material/Card'
import CardActions from '@mui/material/CardActions'
import CardContent from '@mui/material/CardContent'
import BarChartIcon from '@mui/icons-material/BarChart'
import FileDownloadIcon from '@mui/icons-material/FileDownload'
import { PieChart } from '@mui/x-charts/PieChart'
import { Tooltip } from '@mui/material'
import { always, compose } from 'ramda'

import axios, { pluckData } from 'src/utilities/http-client'
import { useAppDispatch, useAppSelector } from 'src/store/hooks'
import noop from 'src/utilities/noop'
import { downloadFile } from 'src/v3/utilities/filesystem'
import {
  dashboardChartExpandedChanged,
  fetchAccessLevelLinkedServicesCountChart,
  selectAccessLevelLinkedServicesCountChart,
  selectAccessLevelLinkedServicesCountChartStatus,
  selectDashboardChartExpanded,
} from '../../admin.slice'

let exportAccessLevelLinkedServices = () =>
  axios.get('/api/v2/admin/access-level/linked-services/export').then(pluckData)

export default () => {
  let dispatch = useAppDispatch()
  let accessLevelLinkedServiceChart = useAppSelector(
    selectAccessLevelLinkedServicesCountChart,
  )
  let accessLinkedServicesChartStatus = useAppSelector(
    selectAccessLevelLinkedServicesCountChartStatus,
  )
  let expandedChart = useAppSelector(selectDashboardChartExpanded)

  useEffect(() => {
    if (accessLinkedServicesChartStatus === 'uninitialized') {
      dispatch(fetchAccessLevelLinkedServicesCountChart())
    }
  }, [accessLinkedServicesChartStatus])

  return (
    <Card>
      <CardContent>
        <div className="chart-card w-full pb-2">
          <PieChart
            series={[
              {
                data: accessLevelLinkedServiceChart,
              },
            ]}
            height={expandedChart === 'AccessLevelLinkedServices' ? 500 : 200}
          />
        </div>
        <Typography gutterBottom variant="h5" component="div">
          Access Level
        </Typography>
        <Typography gutterBottom variant="h6" component="div">
          Linked Services
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Amount of linked services per access level, such as Bound Tree limited
          or full access.
        </Typography>
      </CardContent>
      <CardActions>
        <Tooltip title="View Chart">
          <IconButton
            size="small"
            onClick={
              compose(
                dispatch,
                dashboardChartExpandedChanged,
                always(
                  expandedChart === 'AccessLevelLinkedServices'
                    ? 'None'
                    : 'AccessLevelLinkedServices',
                ) as any,
              ) as any
            }
          >
            <BarChartIcon />
          </IconButton>
        </Tooltip>
        <Tooltip title="Export">
          <IconButton
            size="small"
            onClick={() =>
              exportAccessLevelLinkedServices()
                .then((response) =>
                  downloadFile(response, 'linked_service_list.csv'),
                )
                .catch(noop)
            }
          >
            <FileDownloadIcon />
          </IconButton>
        </Tooltip>
      </CardActions>
    </Card>
  )
}
